export const SIGN_UP_PHOTOGRAPHER_REQUEST = "sign_up_photographer_request";
export const SIGN_UP_PHOTOGRAPHER_SUCCESS = "sign_up_photographer_success";
export const SIGN_UP_PHOTOGRAPHER_FAILURE = "sign_up_photographer_failure";

export const SIGN_IN_PHOTOGRAPHER_REQUEST = "sign_in_photographer_request";
export const SIGN_IN_PHOTOGRAPHER_SUCCESS = "sign_in_photographer_success";
export const SIGN_IN_PHOTOGRAPHER_FAILURE = "sign_in_photographer_failure";

export const CLEAR_AUTH_STATES = "clear_auth_states";
